// extracted by mini-css-extract-plugin
export default {"row":"Blog_row__B5Hnw","itemblog":"Blog_itemblog__yRG64","links":"Blog_links__+Q42G"};